import { Core } from "@/core/Core";

export default {

  async getCompanyParentConfiguration(context, {branchId, companyId}) {
    try {
      return await Core.request("GET", "/api/branches/" + branchId + "/companies/" + companyId + "/parent_config");
    } catch (e) {
      return null;
    }
  },

  async getCompany(context, {branchId, companyId, fallback, augment}) {
    try {
      return await Core.request("GET", `/api/branches/${branchId}/companies/${companyId}?fallback=${fallback ? 1 : 0}&augment=${augment ? augment : 'backend'}`);
    } catch (e) {
      return null;
    }
  },

  async getCompanies(context, branchId) {
    try {
      return await Core.request("GET", `/api/branches/${branchId}/companies`);
    } catch (e) {
      return null;
    }
  },

  async saveCompany(context, {branchId, companyId, fallback, augment, data}) {
    try {
      return await Core.request("PUT",`/api/branches/${branchId}/companies/${companyId}?fallback=${fallback ? 1 : 0}&augment=${augment ? augment : null}`, data);
    } catch (e) {
      return null;
    }
  },

  async deleteCompany(context, {branchId, companyId}) {
    try {
      return await Core.request("DELETE", "/api/branches/" + branchId + "/companies/" + companyId);
    } catch (e) {
      return null;
    }
  },

  async createCompany(context, {branchId, augment, data}) {
    try {
      return await Core.request("POST", `/api/branches/${branchId}/companies?augment=${augment || null}`, data);
    } catch (e) {
      return null;
    }
  },

  async generateKioskLogin(context, {branchId}) {
    try {
      return await Core.request("POST", "/api/kiosk_login", {
        branch: branchId
      });
    } catch (e) {
      return null;
    }
  },

  async getHolidayHours(context, {companyId}) {
    try {
      return await Core.request("GET", `/api/companies/${companyId}/holiday_hours`);
    } catch (e) {
      return null;
    }
  },

  async saveHolidayHours(context, {companyId, data}) {
    try {
      return await Core.request("POST", `/api/companies/${companyId}/holiday_hours`, {holidayHours: data});
    } catch (e) {
      return null;
    }
  }
}
